import { useEffect } from 'react';
import { useNavigate, useRouteError, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';

type ErrorBoundaryProps = {
  errorMessage: string;
  redirectUrl?: string | null;
};

export const ErrorBoundary = ({ redirectUrl = '/', errorMessage }: ErrorBoundaryProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const error = useRouteError();

  useEffect(() => {
    if (redirectUrl && location.pathname !== redirectUrl) {
      navigate(redirectUrl);
    }
    const errorType = error as Error;

    // eslint-disable-next-line
    console.error(error);

    toast.error(
      <div className="flex flex-col gap-1">
        <span className="text-m-m text-danger">{errorMessage}</span>
        <span className="text-s-sb text-danger">{errorType.message}</span>
      </div>,
      { toastId: 'error' },
    );
  }, [navigate, location.pathname, redirectUrl, errorMessage, error]);

  return null;
};
